module.exports = __webpack_public_path__ + "static/bg-hero-right-large-25d01fa0b1f0f33061dc47e277562769.svg";